import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function BookingConfirmModal({ course, onClose, onConfirm }) {
  const [confirmed, setConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setConfirmed(true);
      onConfirm(course);
    }, 1200);
  };

  if (!course) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={!loading ? onClose : undefined} />
      <div className="relative bg-[var(--color-card)] rounded-2xl shadow-[var(--shadow-xl)] w-full max-w-md z-10 p-6">
        {!confirmed ? (
          <>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl bg-[var(--color-primary)] flex items-center justify-center">
                <Icon name="BookOpen" size={20} color="#fff" />
              </div>
              <div>
                <h2 className="font-heading font-bold text-base text-[var(--color-foreground)]">Confirm Enrollment</h2>
                <p className="text-xs text-[var(--color-muted-foreground)]">Review your booking details</p>
              </div>
            </div>

            <div className="bg-[var(--color-muted)] rounded-xl p-4 mb-4 space-y-2">
              <p className="font-semibold text-sm text-[var(--color-foreground)]">{course?.title}</p>
              <div className="flex items-center gap-2 text-xs text-[var(--color-muted-foreground)]">
                <Icon name="Calendar" size={12} color="currentColor" />
                <span>{course?.nextSession}</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-[var(--color-muted-foreground)]">
                <Icon name="Clock" size={12} color="currentColor" />
                <span>{course?.duration}</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-[var(--color-muted-foreground)]">
                <Icon name="User" size={12} color="currentColor" />
                <span>{course?.instructor}</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-[var(--color-muted-foreground)]">
                <Icon name="MapPin" size={12} color="currentColor" />
                <span>{course?.location}</span>
              </div>
            </div>

            <p className="text-xs text-[var(--color-muted-foreground)] mb-4">
              By confirming, you agree to attend this training session. A confirmation email will be sent to your registered address.
            </p>

            <div className="flex gap-3">
              <Button variant="outline" onClick={onClose} disabled={loading} className="flex-1">
                Cancel
              </Button>
              <Button variant="default" loading={loading} onClick={handleConfirm} className="flex-1">
                Confirm Booking
              </Button>
            </div>
          </>
        ) : (
          <div className="text-center py-4">
            <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
              <Icon name="CheckCircle2" size={32} color="var(--color-success)" />
            </div>
            <h2 className="font-heading font-bold text-lg text-[var(--color-foreground)] mb-2">Booking Confirmed!</h2>
            <p className="text-sm text-[var(--color-muted-foreground)] mb-1">
              You have successfully enrolled in
            </p>
            <p className="font-semibold text-sm text-[var(--color-primary)] mb-4">{course?.title}</p>
            <div className="bg-[var(--color-muted)] rounded-lg p-3 text-xs text-[var(--color-muted-foreground)] mb-5">
              <p>📅 {course?.nextSession} · 📍 {course?.location}</p>
            </div>
            <Button variant="default" onClick={onClose} fullWidth iconName="Check" iconPosition="left">
              Done
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}